import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
// import { adminMainUrl } from "../../../Config";
import Cookies from "js-cookie";
import { BeatLoader } from "react-spinners";
// import EditQuoteForm from './modal/EditQuoteForm';
import "react-datepicker/dist/react-datepicker.css";
import { useFormik } from "formik";
import axios from 'axios';
import Accordion from 'react-bootstrap/Accordion';
import { toast } from 'react-toastify';
import { adminMainUrl } from "../../Config";
import { RemarkModal } from "../Modal/RemarkModal";
import EditQuoteForm from "./modal/EditQuoteForm";
// import SendPricing from "./modal/SendPricing";
import { useDispatch, useSelector } from "react-redux";
import { getQuoteCompGenInfo } from "../../Redux/action/Sales/QuoteAirExportCompGenInfoAction";
import SendPricing from "./modal/SendPricing";
import SendForPricingModal from "./modal/SendForPricingModal";
import SendRePricing from "./modal/SendRePricing";
import AddAditional from "./modal/AddAditional";
import { getQuoteDetail } from "../../Redux/action/Sales/LeadStatusAction";
import { capitalizeFirstLetter, DDMMMYYYYformateDate } from "../../HelperFunctions";

const QueryViewInformation = ({ accessedPermission, accessedModules, showSideNavBar }) => {
    // console.log(accessedPermission);
    let user_id = Cookies.get('flexichain_user_id');
    const dispatch = useDispatch();
    const [quotationId, setQuotationId] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [spinnerLoader, setSpinnerLoader] = useState(true);
    const [viewData, setViewData] = useState([]);
    const [show, setShow] = useState(false);
    const [showPageLoader, setShowPageLoader] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showRemark, setShowRemark] = useState(false);
    const handleCloseRemark = () => setShowRemark(false);
    const handleShowRemark = () => setShowRemark(true);
    const [additionalsArray, setAdditionalArray] = useState([]);
    const [showPricing, setShowPricing] = useState(false);
    const handleClosePricing = () => setShowPricing(false);
    const handleShowPricing = () => setShowPricing(true);

    const [showAssignPricingModal, setShowAssignPricingModal] = useState(false);
    const [pricingCompanyValues, setPricingCompanyValues] = useState(null);
    const [assignPricingMode, setAssignPricingMode] = useState("pricing"); // "pricing" or "repricing"

    const handleCloseAssignPricing = () => {
        setShowAssignPricingModal(false);
        setPricingCompanyValues(null);
        setAssignPricingMode("pricing");
    };
    const handleProceedToAssign = (companyValues, mode = "pricing") => {
        setPricingCompanyValues(companyValues);
        setAssignPricingMode(mode);
        setShowAssignPricingModal(true);
    };
    const [originType, setOriginType] = useState("");
    const [destinationType, setDestinationType] = useState("");
    const [shipmentMode, setShipmentMode] = useState("air");
    const [message_id, setMessage_id] = useState("");

    const location = useLocation();
    const { b64id } = useParams();

    const token = Cookies.get("token")
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    let id = atob(b64id);

    useEffect(() => {
        if (!token) {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        } else {
            if (b64id) {
                // If user is from pricing module and does not have sales_and_crm, redirect to pricing give-rate view
                const hasSales = accessedModules && accessedModules.includes('sales_and_crm');
                const hasPricing = accessedModules && accessedModules.includes('pricing');
                if (!hasSales && hasPricing) {
                    navigate(`/flexichain/query-import-give-rate/${b64id}`, { replace: true });
                    return;
                }

                setQuotationId(id);
                if (user_id) {
                    dispatch(getQuoteDetail(token, user_id, id));
                }
            } else {
                toast.error("Please enter correct url.")
                navigate(-1);
            }
        }
    }, [b64id, user_id, accessedModules]);

    let { loadingQuoteDetail,
        quoteDetailDataError,
        quoteDetailData } = useSelector(state => state?.LeadStatusReducer)


    useEffect(() => {
        if (quoteDetailDataError) {
            const hasPricing = accessedModules && accessedModules.includes('pricing');
            if (hasPricing && b64id) {
                navigate(`/flexichain/query-import-give-rate/${b64id}`, { replace: true });
            }
        }
    }, [quoteDetailDataError, accessedModules, b64id]);



    useEffect(() => {
        if (loadingQuoteDetail) {
            setSpinnerLoader(true);
        } else {
            setSpinnerLoader(false);
        }


        if (quoteDetailData) {

            // console.log(quoteDetailData);

            if (quoteDetailData?.additional_info) {
                setAdditionalArray(quoteDetailData?.additional_info)
            }

            if (quoteDetailData?.shipment_mode) {
                if (quoteDetailData?.shipment_mode == "air" || quoteDetailData?.shipment_mode == "ocean") { setShipmentMode(quoteDetailData?.shipment_mode) }
            }

            if (quoteDetailData?.mail_message_id) {
                setMessage_id(quoteDetailData?.mail_message_id);
            }


            if (quoteDetailData?.shipment_mode == "courier") {
                setOriginType("");
                setDestinationType("")
            }
            if (quoteDetailData?.shipment_mode == "air") {
                setOriginType(`(${quoteDetailData?.origin_type})`);
                setDestinationType(`(${quoteDetailData?.destination_type})`);
            } else if (quoteDetailData?.shipment_mode == "ocean") {
                if (quoteDetailData?.origin_type == "AIRPORT") {
                    setOriginType(`(SEAPORT)`)
                } else {
                    setOriginType(`(${quoteDetailData?.origin_type})`);
                }

                if (quoteDetailData?.destination_type == "AIRPORT") {
                    setDestinationType(`(SEAPORT)`)
                } else {
                    setDestinationType(`(${quoteDetailData?.destination_type})`);
                }

            }
        }
    }, [loadingQuoteDetail, quoteDetailDataError, quoteDetailData]);


    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(false);

    const handleToggle = () => {
        setIsVisible(!isVisible);
    };

    const openNewWindow = (url) => {
        const newWindow = window.open(
            url, // URL of the new window
            '_blank', // Target window name
            'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1000,height=600' // Window features
        );

        const interval = setInterval(() => {
            if (newWindow.closed) {
                clearInterval(interval);
                refresh();
            }
        }, 500);
    };



    const sendMessageToParent = () => {
        // Check if the opener window exists
        if (window.opener) {
            // Send a message to the parent window
            window.opener.postMessage('refreshQueryTableData', '*');
        }
    };


    const ViewQuotation = async (information) => {
        setSpinnerLoader(true)
        try {
            const token = Cookies.get("token");
            const requesId = {
                quotation_id: `${quotationId}`,
            };

            const response = await fetch(`${adminMainUrl}/api/quotation/view`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": token,
                    'user_id': user_id,
                },
                body: JSON.stringify(requesId),
            });
            if (!response.ok) {
                setSpinnerLoader(false);
                toast.error(data?.msg);
                setIsVisible(false);
                navigate(-1)
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            // toast.success(data?.msg);
            setViewData(data?.data);
            setIsVisible(false)
            setSpinnerLoader(false);
        } catch (error) {
            setIsVisible(false)
            setSpinnerLoader(false);
            console.log(error);
        }
    };

    const followUp = () => {
        // openNewWindow(`/flexichain/follow-up`)
        const gmailUrl = `https://mail.google.com/mail/u/0/#search/rfc822msgid:${message_id}`;
        openNewWindow(gmailUrl);
    }

    const sentQuotation = async (quotationId) => {
        try {
            const token = Cookies.get("token");
            const filteredEmails = ccEmails
                .map(e => e.trim())
                .filter(e => e !== "");
            const requesId = {
                quotation_id: `${quotationId}`,
                cc_emails: filteredEmails,
            };
            const response = await fetch(`${adminMainUrl}/api/quotation/to_be_quotation_sent`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": token,
                    'user_id': user_id,
                },
                body: JSON.stringify(requesId),
            });
            const data = await response.json();
            if (!response.ok) {

                toast.error(data?.msg);
                // navigate(`/flexichain/quotation-sent-query-list`)
                return;
            }
            toast.success(data?.msg);
            setShowSendModal(false);
            setCcEmails([""]);
            sendMessageToParent();
            // navigate(-1, { state: { quotationId: "6" } });
            refresh();
        } catch (error) {
            console.log(error);
            toast.error(error);
        }
    };

    const ConvertedType = async (quotationId) => {
        try {
            const token = Cookies.get("token");
            const requesId = {
                quotation_id: `${quotationId}`,
            };
            const response = await fetch(`${adminMainUrl}/api/quotation/to_be_converted`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": token,
                    'user_id': user_id,
                },
                body: JSON.stringify(requesId),
            });
            const data = await response.json();
            if (!response.ok) {
                toast.error(data?.msg);
                return;
                // navigate(`/flexichain/converted-query-list`);
            }
            toast.success(data?.msg);
            // navigate(-1, { state: { quotationId: "7" } });
            sendMessageToParent();
            refresh();

        } catch (error) {
            console.log(error);
            toast.error(error);
        }
    };

    const GenerateCredentials = async (quotationId) => {
        try {
            const token = Cookies.get("token");
            const requesId = {
                quotation_id: `${quotationId}`,
            };
            const response = await fetch(`${adminMainUrl}/api/quotation/generate_client_credentials`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": token,
                    'user_id': user_id,
                },
                body: JSON.stringify(requesId),
            });
            const data = await response.json();
            if (!response.ok) {
                toast.error(data?.msg);
                return;
                // navigate(`/flexichain/converted-query-list`);
            }
            toast.success(data?.msg);
            // navigate(-1, { state: { quotationId: "7" } });
            sendMessageToParent();
            refresh();

        } catch (error) {
            console.log(error);
            toast.error(error);
        }
    };

    const NotConverted = async (quotationId) => {
        try {
            const token = Cookies.get("token");
            const requesId = {
                quotation_id: `${quotationId}`,
            };
            const response = await fetch(`${adminMainUrl}/api/quotation/to_be_not_converted`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": token,
                    'user_id': user_id,
                },
                body: JSON.stringify(requesId),
            });
            const data = await response.json();
            if (!response.ok) {
                toast.error(data?.msg);
                return;
                // throw new Error(`HTTP error! status: ${response.status}`);
            }
            toast.success(data?.msg);
            // navigate(-1, { state: { quotationId: "8" } });
            sendMessageToParent();
            refresh();
        } catch (error) {
            console.log(error);
            toast.error(error);
        }
    };

    const priceView = async (quotationId) => {
        try {
            const token = Cookies.get("token");
            const requesId = {
                quotation_id: `${quotationId}`,
            };
            const response = await fetch(`${adminMainUrl}/api/quotation/to_be_price_viewed`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": token,
                    'user_id': user_id,
                },
                body: JSON.stringify(requesId),
            });
            const data = await response.json();
            if (!response.ok) {
                toast.error(data?.msg);
                return;
                // throw new Error(`HTTP error! status: ${response.status}`);
            }
            toast.success(data?.msg);
            // navigate(`/flexichain/export-view-rates/${btoa(quotationId)}`);
            // window.open(`/flexichain/export-view-rates-${shipmentMode}/${btoa(quotationId)}`);
            refresh();
            sendMessageToParent();
            openNewWindow(`/flexichain/export-view-rates-${shipmentMode}/${btoa(quotationId)}`);

        } catch (error) {
            // toast.error(error);
            console.log(error);
        }
    };

    const [showRepricing, setShowRepricing] = useState(false);
    const handleCloseRepricing = () => setShowRepricing(false);
    const handleShowRepricing = () => setShowRepricing(true);
    const [navigateBack, setNavigateBack] = useState("all");
    const [showSendModal, setShowSendModal] = useState(false);
    const [ccEmails, setCcEmails] = useState([""]);
    const [selectedQuotationId, setSelectedQuotationId] = useState(null);

    useEffect(() => {
        if (!token) {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        } else {
            if (user_id) {
                dispatch(getQuoteCompGenInfo(token, user_id, atob(b64id)));
            }
        }
    }, [token, user_id]);

    const { loadingQuoteCompGenInfoApi, quoteCompGenInfoDataError, quoteCompGenInfoData } = useSelector(state => state?.QuoteAirExportCompGenInfoReducer);

    useEffect(() => {
        if (loadingQuoteCompGenInfoApi) {
            setShowPageLoader(true)
        } else {
            setShowPageLoader(false)
        }

    }, [loadingQuoteCompGenInfoApi, quoteCompGenInfoDataError, quoteCompGenInfoData]);

    const openSendQuotationModal = (quotationId) => {
        setSelectedQuotationId(quotationId);
        setShowSendModal(true);
    };

    const handleAddRow = () => {
        setCcEmails(prev => [...prev, ""]);
    };

    const handleRemoveRow = (index) => {
        setCcEmails(prev => prev.filter((_, i) => i !== index));
    };

    const handleEmailChange = (value, index) => {
        const updated = [...ccEmails];
        updated[index] = value;
        setCcEmails(updated);
    };

    function formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };


    const refresh = () => {
        if (user_id) {
            dispatch(getQuoteDetail(token, user_id, id));
        }
    }

    const formik = useFormik({
        initialValues: {
            remarks: '', // Add an initial value for remarks
        },
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setIsSubmitting(true);
            try {
                const token = Cookies.get("token");
                const requestId = {
                    quotation_id: id,
                    remarks: values.remarks, // Pass the remarks from the form
                };
                const response = await fetch(`${adminMainUrl}/api/pricing/store-remarks`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "auth-token": token,
                        'user_id': user_id,
                    },
                    body: JSON.stringify(requestId),
                });
                // ViewQuotation()
                const result = await response.json(); // Parse the response
                resetForm(); // Reset form fields
                toast.success(result.msg); // Display the success message
                setSubmitting(false);
                refresh();
            } catch (error) {
                console.error(error);
                setSubmitting(false);
                navigate("error-404")
            } finally {
                setIsSubmitting(false); // Stop the spinner
                setIsVisible(false)
            }
        },
    });


    const buttonConfig = {
        "Default": [
            {
                text: "View Remark",
                className: "btn btn-danger",
                onClick: handleShowRemark,
            },
        ],
        "Picked": [

            {
                text: "Send for Pricing",
                className: "btn btn-danger",
                onClick: handleShowPricing,
                condition: quoteDetailData?.last_status_id !== 3,
            },
            {
                text: "View Remark",
                className: "btn btn-danger",
                onClick: handleShowRemark,
            },
        ],
        "Sent for Price": [
            {
                text: "Send for Pricing",
                className: "btn btn-danger",
                onClick: handleShowPricing,
                condition: quoteDetailData?.last_status_id !== 3,
            },
            {
                text: "View Remark",
                className: "btn btn-danger",
                onClick: handleShowRemark,
            },
        ],
        "Price Received": [
            {
                text: "View Rates",
                className: "btn btn-danger",
                onClick: () => priceView(quotationId),
            },
            {
                text: "View Remark",
                className: "btn btn-danger",
                onClick: handleShowRemark,
            }
        ],
        "Price Viewed": [
            // {
            //     text: "Repricing",
            //     className: "btn btn-danger",
            //     onClick: handleShowRepricing,
            // },
            {
                text: "Send to Client",
                className: "btn btn-danger",
                // onClick: () => sentQuotation(quoteDetailData?.id),
                onClick: () => openSendQuotationModal(quoteDetailData?.id)
            },
            {
                text: "View Rates",
                className: "btn btn-danger",
                onClick: () => openNewWindow(`/flexichain/export-view-rates-${shipmentMode}/${btoa(quotationId)}`),
            },
            {
                text: "View Remark",
                className: "btn btn-danger",
                onClick: handleShowRemark,
            }
        ],
        "Quotation Sent": [
            {
                text: "Convert",
                className: "btn btn-danger",
                onClick: () => ConvertedType(quoteDetailData?.id),
            },
            {
                text: "Not Convert",
                className: "btn btn-danger",
                onClick: () => NotConverted(quoteDetailData?.id),
            },
            {
                text: "Repricing",
                className: "btn btn-danger",
                onClick: handleShowRepricing,
            },
            {
                text: "View Rates",
                className: "btn btn-danger",
                onClick: () => openNewWindow(`/flexichain/export-view-rates-${shipmentMode}/${btoa(quotationId)}`),
            },
            {
                text: "View Remark",
                className: "btn btn-danger",
                onClick: handleShowRemark,
            }
        ],
        "Repricing": [
            {
                text: "View Rates",
                className: "btn btn-danger",
                onClick: () => openNewWindow(`/flexichain/export-view-rates-${shipmentMode}/${btoa(quotationId)}`),
            },
            // {
            //     text: "View Rates",
            //     className: "btn btn-danger",
            //     onClick: () => openNewWindow(`/flexichain/export-view-rates-${shipmentMode}/${btoa(quotationId)}`),
            // },
            {
                text: "View Remark",
                className: "btn btn-danger",
                onClick: handleShowRemark,
            }
        ],
        "Converted": [
            // {
            //     text: "Follow-Up",
            //     className: "btn btn-danger",
            //     onClick: followUp,
            // },
            {
                text: "View Rates",
                className: "btn btn-danger",
                onClick: () => openNewWindow(`/flexichain/export-view-rates-${shipmentMode}/${btoa(quotationId)}`),
            },
            {
                text: "View Remark",
                className: "btn btn-danger",
                onClick: handleShowRemark,
            },
            ...((quoteDetailData && quoteDetailData?.customer_username)
                ? [
                    {
                        text: "Resend credentials",
                        className: "btn btn-danger",
                        onClick: () => GenerateCredentials(quoteDetailData?.id),
                    },
                ]
                : [
                    {
                        text: "Send credentials",
                        className: "btn btn-danger",
                        onClick: () => GenerateCredentials(quoteDetailData?.id),
                    },
                ]),
        ],

        "Not Converted": [
            // {
            //     text: "Follow-Up",
            //     className: "btn btn-danger",
            //     onClick: followUp,
            // },
            {
                text: "View Remark",
                className: "btn btn-danger",
                onClick: handleShowRemark,
            }
        ],



    };




    return (
        <div className={showSideNavBar ? "page-wrapper" : ""}>
            <div className={showSideNavBar ? "content" : 'content m-3'}>
                <div className="row">
                    <div className="col-md-12">
                        {/* Page Header */}
                        {/* <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col-sm-4">
                                    <h4 className="page-title">
                                        View Information
                                    </h4>
                                </div>
                                <div className="col-sm-8 text-sm-end">
                                </div>
                            </div>
                        </div> */}
                        {/* /Page Header */}
                    </div>
                </div>
                {
                    spinnerLoader ?
                        <div
                            className="d-flex justify-content-center align-items-center new_infometion_table"
                            style={{ height: "400px", width: "100%" }}
                        >
                            <BeatLoader />
                        </div> :
                        <div className="row">
                            <div className="col-md-12">
                                {/* Contact User */}
                                <div className="contact-head">
                                    <div className="row align-items-center mb-3 ">
                                        <div className="col-sm-6">
                                            <ul className="contact-breadcrumb">
                                                <li className="mb-0">
                                                    {/* {showSideNavBar && <Link to={-1}>
                                                        <i className="ti ti-arrow-narrow-left" />
                                                        View Information
                                                    </Link>} */}
                                                    <h4 className="page-title">
                                                        View Information
                                                    </h4>
                                                </li>

                                            </ul>
                                        </div>
                                        {/* <div className="col-md-6">
                                            {
                                                quoteDetailData?.quote_status?.name === "Price Received" ?
                                                    <div className="d-flex justify-content-end align-items-center flex-wrap gap-3">
                                                        <div className="">
                                                            <div className="send_query_list_button send-query btn btn-danger" onClick={() => {
                                                                priceView(quotationId)
                                                            }}>
                                                                View Rates
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :
                                                    quoteDetailData?.quote_status?.name === "Converted" ?
                                                        <div className="d-flex justify-content-end align-items-center flex-wrap gap-3">
                                                            <div className="">
                                                                <div className="send_query_list_button send-query btn btn-danger" onClick={() => { navigate(-1) }}>
                                                                    Follow-Up
                                                                </div>
                                                            </div>
                                                        </div>
                                                        :
                                                        quoteDetailData?.quote_status?.name === "Repricing" ?
                                                            <div className="d-flex justify-content-end align-items-center flex-wrap gap-3">
                                                                <div className="">
                                                                    <div className="send_query_list_button send-query btn btn-danger" onClick={() => {
                                                                        openNewWindow(`/flexichain/export-view-rates-${shipmentMode}/${btoa(quotationId)}`)
                                                                    }}>
                                                                        View Rates
                                                                    </div>
                                                                </div>
                                                            </div> :
                                                            quoteDetailData?.quote_status?.name === "Not Converted" ?
                                                                <div className="d-flex justify-content-end align-items-center flex-wrap gap-3">
                                                                    <div className="">
                                                                        <div className="send_query_list_button send-query btn btn-danger" onClick={() => { navigate(-1) }}>
                                                                            Follow-Up
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                :
                                                                quoteDetailData?.quote_status?.name === "Price Viewed" ?
                                                                    <div className="d-flex justify-content-end align-items-center flex-wrap gap-3">
                                                                        <div className="">
                                                                            <button className="send_query_list_button send-query btn btn-danger" onClick={() => {
                                                                                // sendPricing(quoteDetailData?.id)
                                                                                // navigate("/flexichain/all-rate-request", { state: { quotationId: quotationId } });
                                                                                handleShowRepricing();
                                                                            }}>
                                                                                Repricing
                                                                            </button>
                                                                        </div>
                                                                        <div className="">
                                                                            <div className="send_query_list_button send-query btn btn-danger" onClick={() => {

                                                                                sentQuotation(quoteDetailData?.id)
                                                                            }}>
                                                                                Send to Client
                                                                            </div>
                                                                        </div>
                                                                        <div className="">
                                                                            <div className="send_query_list_button send-query btn btn-danger" onClick={() => {
                                                                                // navigate(`/flexichain/export-view-rates-${shipmentMode}/${btoa(quotationId)}`)
                                                                                // window.open(`/flexichain/export-view-rates-${shipmentMode}/${btoa(quotationId)}`)
                                                                                openNewWindow(`/flexichain/export-view-rates-${shipmentMode}/${btoa(quotationId)}`)
                                                                            }}>
                                                                                View Rates
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    quoteDetailData?.quote_status?.name === "Quotation Sent" ?
                                                                        <div className="d-flex justify-content-end align-items-center flex-wrap gap-3">
                                                                            <div className="contacts-action">
                                                                                <div className="send_query_list_button send-query btn btn-danger" onClick={() => {
                                                                                    ConvertedType(quoteDetailData?.id)
                                                                                }}>
                                                                                    Convert
                                                                                </div>
                                                                            </div>
                                                                            <div className="contacts-action">
                                                                                <div className="send_query_list_button send-query btn btn-danger" onClick={() => {
                                                                                    NotConverted(quoteDetailData?.id)
                                                                                }}>
                                                                                    Not Convert
                                                                                </div>
                                                                            </div>
                                                                            <div className="">
                                                                                <button className="send_query_list_button send-query btn btn-danger" onClick={() => {
                                                                                    handleShowRepricing();
                                                                                }}>
                                                                                    Repricing
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        :
                                                                        <div className="d-flex justify-content-end align-items-center flex-wrap gap-3">
                                                                            <div className=" contacts-action">
                                                                                <div
                                                                                    className="send_query_list_button send-query btn btn-danger"
                                                                                    onClick={() => { navigate(`/flexichain/quote-form/edit/${btoa(quotationId)}`) }}
                                                                                >
                                                                                    Edit
                                                                                </div>
                                                                            </div>
                                                                            {
                                                                                quoteDetailData?.last_status_id !== 3 &&
                                                                                <div className="contacts-action">
                                                                                    <div
                                                                                        className="send_query_list_button send-query btn btn-danger"
                                                                                        onClick={() => {
                                                                                            // sendPricing(quoteDetailData?.id)
                                                                                            // navigate("/flexichain/query-list", { state: { quotationId: 3 } });
                                                                                            handleShowPricing()
                                                                                        }}
                                                                                    >

                                                                                        Send for Pricing
                                                                                    </div>



                                                                                </div>
                                                                            }
                                                                            {
                                                                                <div className="contacts-action">
                                                                                    <div
                                                                                        onClick={handleShowRemark}
                                                                                        className="send_query_list_button send-query btn btn-danger"
                                                                                    >
                                                                                        View Remark
                                                                                    </div>
                                                                                </div>

                                                                            }
                                                                        </div>
                                            }
                                        </div> */}

                                        <div className="col-md-6">
                                            <div className="d-flex justify-content-end align-items-center flex-wrap gap-3">
                                                {(buttonConfig[quoteDetailData?.quote_status?.name] || buttonConfig["Default"]).map((button, index) => {
                                                    if (button.condition === false) return null; // Skip buttons with a false condition
                                                    return (
                                                        <div key={index} className="contacts-action">
                                                            <div className={button.className} onClick={button.onClick}>
                                                                {button.text}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>


                                    </div>
                                </div>
                                <div className="card mb-2">
                                    <div className="card-body pb-2">
                                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                                            <div className="d-lg-flex align-items-start mb-2 w-100 justify-content-between">

                                                <div>
                                                    <div className="d-flex justify-content-start gap-2 py-1">
                                                        <p className="font-medium">Name </p>
                                                        {/* <div className="box-query"> */}
                                                        <p className="mb-0 text-sm">{quoteDetailData?.full_name} ({quoteDetailData?.quotation_user_type})</p>
                                                        {/* </div> */}
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-1">
                                                        <p className="font-medium">Email </p>
                                                        {/* <div className="box-query"> */}
                                                        <p className="mb-0 text-sm">{quoteDetailData?.email}</p>
                                                        {/* </div> */}
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-1">
                                                        <p className="font-medium">Mobile </p>
                                                        {/* <div className="box-query"> */}
                                                        <p className="mb-0 text-sm">{quoteDetailData?.phone}</p>
                                                        {/* </div> */}
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-1">
                                                        <p className="font-medium">Created At </p>
                                                        {/* <div className="box-query"> */}
                                                        <p className="mb-0 text-sm">{DDMMMYYYYformateDate(quoteDetailData?.createdAt)}</p>
                                                        {/* </div> */}
                                                    </div>

                                                </div>

                                                <div>
                                                    <div className="d-flex justify-content-start gap-2 py-1">
                                                        <p className="font-medium">Request No </p>
                                                        {/* <div className="box-query"> */}
                                                        <p className="mb-0 text-sm">{quoteDetailData?.request_no}</p>
                                                        {/* </div> */}
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-1">
                                                        <p className="font-medium">Status </p>
                                                        {/* <div className="box-query"> */}
                                                        <p className="mb-0 text-sm">{quoteDetailData?.quote_status?.name}</p>
                                                        {/* </div> */}
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-1">
                                                        <p className="font-medium">Picked by </p>
                                                        {/* <div className="box-query"> */}
                                                        <p className="mb-0 text-sm">{quoteDetailData?.picked_user ? `${quoteDetailData?.picked_user?.name}` : "-"}</p>
                                                        {/* </div> */}
                                                    </div>

                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                                {/* /Contact User */}
                            </div>
                            <div className="col-xl-12">
                                <div className="card mb-2">
                                    <div className="card-body pb-0 pt-2">
                                        <ul className="nav nav-tabs nav-tabs-bottom" role="tablist">
                                            <li className="nav-item" role="presentation">
                                                <a
                                                    href="#"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#activities"
                                                    className="nav-link active"
                                                >
                                                    <i className="ti ti-alarm-minus me-1" />
                                                    Pickup Information
                                                </a>
                                            </li>


                                        </ul>
                                    </div>
                                </div>
                                {/* Tab Content */}
                                <div className="tab-content pt-0">
                                    {/* Activities */}
                                    <div className="tab-pane active show" id="activities">
                                        <div className="card">

                                            <div className="card-body">
                                                <div className="pb-4 px-md-0 px-3 view-info-box">

                                                    <div className="row">
                                                        <div className=" col-md-6 py-2">

                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Origin </p>
                                                                {/* <div className="box-query"> */}
                                                                <p className="mb-0 text-sm">
                                                                    {quoteDetailData?.origin_type == "AIRPORT" ?
                                                                        `${quoteDetailData?.origin_port_full_name} (${quoteDetailData?.origin_type})` :
                                                                        `${quoteDetailData?.origin_address}, ${quoteDetailData?.origin_city ? quoteDetailData?.origin_city?.name : ""}, ${quoteDetailData?.origin_state ? quoteDetailData?.origin_state?.name : ""}, ${quoteDetailData?.origin_country ? quoteDetailData?.origin_country?.name : ""} (${quoteDetailData?.origin_type})`}
                                                                </p>
                                                                {/* </div> */}
                                                            </div>
                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Destination</p>
                                                                {/* <div className="box-query"> */}

                                                                <p className="mb-0 text-sm">{quoteDetailData?.destination_type == "AIRPORT" ?
                                                                    `${quoteDetailData?.destination_port_full_name} (${quoteDetailData?.destination_type})` :
                                                                    `${quoteDetailData?.destination_address}, ${quoteDetailData?.destination_city ? quoteDetailData?.destination_city?.name : ""}, ${quoteDetailData?.destination_state ? quoteDetailData?.destination_state?.name : ""}, ${quoteDetailData?.destination_country ? quoteDetailData?.destination_country?.name : ""} (${quoteDetailData?.destination_type})`}</p>
                                                                {/* </div> */}
                                                            </div>
                                                            {quoteDetailData?.shipment_mode !== "courier" && <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Incoterm</p>

                                                                <p className="mb-0 text-sm">{quoteDetailData?.incoterm ? quoteDetailData?.incoterm?.name : <i>N/A</i>}</p>

                                                            </div>}
                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Commodity</p>

                                                                <p className="mb-0 text-sm">{quoteDetailData?.commodity ? quoteDetailData?.commodity.name : <i>N/A</i>}</p>

                                                            </div>




                                                        </div>
                                                        <div className=" col-md-6 py-2">
                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Shipment Mode </p>
                                                                {/* <div className="box-query"> */}
                                                                <p className="mb-0 text-sm">{quoteDetailData?.shipment_mode ? capitalizeFirstLetter(quoteDetailData?.shipment_mode) : ""}</p>
                                                                {/* </div> */}
                                                            </div>


                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Cargo Ready Date </p>
                                                                {/* <div className="box-query"> */}

                                                                <p className="mb-0 text-sm">{DDMMMYYYYformateDate(quoteDetailData?.cargo_ready_date)}</p>
                                                                {/* </div> */}
                                                            </div>

                                                            {quoteDetailData && quoteDetailData?.shipment_mode !== "air" && quoteDetailData?.shipment_mode !== "courier" ? <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Load Type </p>
                                                                {/* <div className="box-query"> */}

                                                                <p className="mb-0 text-sm">{quoteDetailData?.load_type}</p>
                                                                {/* </div> */}
                                                            </div> : ""}
                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Service Type</p>

                                                                <p className="mb-0 text-sm">{quoteDetailData?.service_type ? quoteDetailData?.service_type : <i>N/A</i>}</p>

                                                            </div>

                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Pickup Address</p>

                                                                <p className="mb-0 text-sm">{quoteDetailData?.pickup_address ? quoteDetailData?.pickup_address : <i>N/A</i>}</p>

                                                            </div>

                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Drop Address</p>

                                                                <p className="mb-0 text-sm">{quoteDetailData?.drop_address ? quoteDetailData?.drop_address : <i>N/A</i>}</p>

                                                            </div>

                                                        </div>
                                                        <div className="col-12 py-2">
                                                            <div className=" py-2">
                                                                <div className=" d-sm-flex mb-2 align-items-center">
                                                                    <p className="font-medium ">Additionals
                                                                    </p>

                                                                </div>

                                                                <div className="row">
                                                                    {additionalsArray.map((val, _i) => {
                                                                        return (
                                                                            <div className="col-md-3" key={_i + 1}>
                                                                                <div className="form-check form-switch">
                                                                                    <input
                                                                                        className="form-check-input form-switch-add"
                                                                                        type="checkbox"
                                                                                        role="switch"
                                                                                        id={`flexSwitchCheckDefault${_i}`}
                                                                                        value={val?.value}
                                                                                        checked={val.included}
                                                                                        disabled
                                                                                        style={{ opacity: 1 }}
                                                                                    />
                                                                                    <label
                                                                                        className="form-check-label"
                                                                                        htmlFor={`flexSwitchCheckDefault${_i}`}
                                                                                    >
                                                                                        {val.name}
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })}


                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className="col-12 py-2">
                                                            <div className=" py-2">
                                                                <div className=" d-sm-flex mb-2 align-items-center">
                                                                    <p className="font-medium ">Specail Handling
                                                                    </p>

                                                                </div>

                                                                <div className="row">
                                                                    <p className="mb-0 text-sm"> {quoteDetailData?.special_handling ? quoteDetailData?.special_handling : "No"} </p>
                                                                </div>
                                                            </div>

                                                        </div>



                                                        {
                                                            quoteDetailData?.shipment_mode !== 'air' && quoteDetailData?.load_type == "FULL" ?
                                                                <div className="col-12 py-2 ">
                                                                    <p className="font-medium mb-3">Cargo Details</p>
                                                                    <div className="table-responsive">

                                                                        <table className="posts-table mb-0  table table-bordered view-info-table">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th scope="col"> Quantity</th>
                                                                                    <th scope="col">Container Size</th>
                                                                                    <th scope="col">Container Type</th>
                                                                                    <th scope="col">Unit Weight</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>{quoteDetailData?.fl_quantity ?? "N/A"}</td>
                                                                                    <td> {quoteDetailData?.containersize ? quoteDetailData?.containersize?.name : "N/A"}</td>
                                                                                    <td> {quoteDetailData?.containertype ? quoteDetailData?.containertype?.name : "N/A"}</td>
                                                                                    <td> {quoteDetailData?.fl_weight} {quoteDetailData?.fl_weight_unit_id ?? "N/A"}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>

                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className="col-12 py-2 ">
                                                                    <p className="font-medium mb-3">Package Dimensions/Weight</p>
                                                                    <div className="table-responsive">
                                                                        <table className="posts-table mb-0  view-info-table">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="p-0">
                                                                                        <tr>
                                                                                            {quoteDetailData?.package_volume_type === "VOLUME" ?

                                                                                                <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                    Volume
                                                                                                </td>
                                                                                                : <><td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                    Length
                                                                                                </td>
                                                                                                    <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                        Width
                                                                                                    </td>
                                                                                                    <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                        Height
                                                                                                    </td></>}
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Package Type
                                                                                            </td>
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Volumetric Weight
                                                                                            </td>
                                                                                            {/* <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Unit
                                                                                            </td> */}
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Gross Weight
                                                                                            </td>
                                                                                            {/* <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Gross Weight Unit
                                                                                            </td> */}
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Total Box
                                                                                            </td>
                                                                                        </tr>
                                                                                        {
                                                                                            quoteDetailData?.package_info ? (
                                                                                                (quoteDetailData?.package_info).map((value, index) => {
                                                                                                    return (
                                                                                                        <tr key={index}>
                                                                                                            {
                                                                                                                quoteDetailData?.package_volume_type === "VOLUME" ?

                                                                                                                    <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                        {value?.volume ? `${value?.volume} ${value?.volumeunit}` : 'N/A'}
                                                                                                                    </td> :

                                                                                                                    <>
                                                                                                                        <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                            {value?.length ? `${value?.length} ${value?.dimensionunit}` : 'N/A'}
                                                                                                                        </td>
                                                                                                                        <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                            {value?.width ? `${value?.width} ${value?.dimensionunit}` : 'N/A'}
                                                                                                                        </td>
                                                                                                                        <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                            {value?.height ? `${value?.height} ${value?.dimensionunit}` : 'N/A'}
                                                                                                                        </td>
                                                                                                                    </>
                                                                                                            }

                                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.package_type ? value?.package_type?.name : 'N/A'}
                                                                                                            </td>
                                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.max_weight ? `${value?.max_weight} ${value?.max_weight_unit}` : 'N/A'}
                                                                                                            </td>
                                                                                                            {/* <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.gross_weight_unit?.name || 'N/A'}
                                                                                                            </td> */}
                                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.gross_weight ? `${value?.gross_weight} ${value?.gross_weight_unit}` : 'N/A'}
                                                                                                            </td>
                                                                                                            {/* <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.gross_weight_unit?.name || 'N/A'}
                                                                                                            </td> */}
                                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.total_boxes || 'N/A'}
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    );
                                                                                                })
                                                                                            ) : (
                                                                                                <tr>
                                                                                                    <td colSpan="9" style={{ border: "1px solid #c7c7c7", textAlign: "center" }}>
                                                                                                        No data available
                                                                                                    </td>
                                                                                                </tr>
                                                                                            )
                                                                                        }
                                                                                    </td>
                                                                                </tr>

                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                        }

                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <table className="posts-table w-100">
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="send_query_list_button w-fit p-0 send-query" style={{ background: "none", color: "#000" }}>
                                                                            <div className="remark-section" >
                                                                                <p id="remarks" onClick={handleToggle} className="text-start" style={{ marginRight: '10px', cursor: 'pointer', color: "#6470c5" }}>
                                                                                    <b>+ Add Remark</b>
                                                                                </p>
                                                                                <form onSubmit={formik.handleSubmit}>
                                                                                    <div id="remarks" style={{ display: isVisible ? "block" : "none" }}>
                                                                                        <textarea
                                                                                            id="remarks-input"
                                                                                            name="remarks"
                                                                                            className="form-control mb-2"
                                                                                            value={formik.values.remarks}
                                                                                            onChange={formik.handleChange}
                                                                                            onBlur={formik.handleBlur}
                                                                                            placeholder="Write Something Here...."
                                                                                            style={{ marginRight: '10px' }}
                                                                                        ></textarea>
                                                                                        {formik.touched.remarks && formik.errors.remarks ? (
                                                                                            <div className="error" style={{ color: 'red' }}>{formik.errors.remarks}</div>
                                                                                        ) : null}
                                                                                        <div className="text-end">
                                                                                            <button className="send_query_list_button send-query desc-btn py-1 btn btn-danger" disabled={isSubmitting}>
                                                                                                {isSubmitting ? <div><i className="fa fa-spinner fa-spin" /> Add</div> : "Add"}
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                </form>
                                                                            </div>
                                                                        </td>
                                                                    </tr>

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                {/* /Tab Content */}
                            </div>
                            {/* /Contact Details */}
                        </div>

                }
            </div>
            {/* <QuotationAirExportModal show={show} handleClose={handleClose} /> */}
            <AddAditional id="add-aditionals" />
            <SendPricing
                quoteDetailData={quoteDetailData}
                handleClose={handleClosePricing}
                show={showPricing}
                quotationId={quotationId}
                quoteCompGenInfoData={quoteCompGenInfoData}
                refresh={refresh}
                sendMessageToParent={sendMessageToParent}
                shipmentMode={quoteDetailData && quoteDetailData?.shipment_mode}
                onProceedToAssign={(values) => handleProceedToAssign(values, "pricing")}
            />
            <SendForPricingModal
                show={showAssignPricingModal}
                handleClose={handleCloseAssignPricing}
                quotationId={quotationId}
                pricingCompanyValues={pricingCompanyValues}
                quoteDetailData={quoteDetailData}
                quoteCompGenInfoData={quoteCompGenInfoData}
                refresh={refresh}
                sendMessageToParent={sendMessageToParent}
                mode={assignPricingMode}
            />
            <SendRePricing
                quoteDetailData={quoteDetailData}
                handleCloseRepricing={handleCloseRepricing}
                show={showRepricing}
                quotationId={quotationId}
                quoteCompGenInfoData={quoteCompGenInfoData}
                refresh={refresh}
                sendMessageToParent={sendMessageToParent}
                shipmentMode={quoteDetailData && quoteDetailData?.shipment_mode}
                onProceedToAssign={(values) => handleProceedToAssign(values, "repricing")}
            />
            {/* <EditQuoteForm show={show} handleClose={handleClose} QuotationId={quotationId} /> */}
            <RemarkModal viewData={quoteDetailData} show={showRemark} handleClose={handleCloseRemark} />
            {showSendModal && (
                <div className="modal show d-block">
                    <div className="modal-dialog">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title">Send Quotation</h5>
                                <button
                                    className="btn-close"
                                    onClick={() => setShowSendModal(false)}
                                />
                            </div>

                            <div className="modal-body">

                                <label className="mb-2">CC Emails</label>

                                {ccEmails.map((email, index) => (
                                    <div key={index} className="d-flex align-items-center mb-2">

                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="Enter CC email"
                                            value={email}
                                            onChange={(e) =>
                                                handleEmailChange(e.target.value, index)
                                            }
                                        />

                                        {/* ADD ICON */}
                                        <span title="Add">
                                            <i
                                                className="ti ti-plus mx-2 add-dimensions-icon"
                                                onClick={handleAddRow}
                                                style={{ cursor: "pointer" }}
                                            ></i>
                                        </span>

                                        {/* DELETE ICON */}
                                        {ccEmails.length > 1 && (
                                            <span title="Delete">
                                                <i
                                                    className="fa-regular fa-trash-can mx-2"
                                                    onClick={() => handleRemoveRow(index)}
                                                    style={{ cursor: "pointer" }}
                                                ></i>
                                            </span>
                                        )}

                                    </div>
                                ))}

                            </div>

                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setShowSendModal(false)}
                                >
                                    Cancel
                                </button>

                                <button
                                    className="btn btn-danger"
                                    onClick={() => sentQuotation(selectedQuotationId)}
                                >
                                    Send
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default QueryViewInformation